import CircularProgress from "@material-ui/core/CircularProgress";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Typography from "@material-ui/core/Typography";
import AphButton from "components/web-ui-components/AphButton";
import { dataLayerTracking } from "gtmTracking";
import { clientRoutes } from "helpers/clientRoutes";
import { getAppStoreLink } from "helpers/commonHelpers";
import { useAuth } from "hooks/authHooks";
import Link from "next/link";
import React, { useEffect, useState, useRef } from "react";
import styles from "./Profile.module.scss";
import dynamic from "next/dynamic";
import clevertapTracking, { eventTracking } from "clevertapTracking";
import {
  getDiagnosticStatus,
  getPatientAttributes,
  getPatientDetails,
  getCommonPatientAttributes,
} from "helpers/commonHelpers";
import { useApolloClient } from "react-apollo-hooks";
import {
  getDiagnosticOrdersListByMobile,
  getDiagnosticOrdersListByMobileVariables,
  getDiagnosticOrdersListByMobile_getDiagnosticOrdersListByMobile_ordersList as OrderListByMobile,
} from "graphql/types/getDiagnosticOrdersListByMobile";
import { GenerateIcon } from "helpers/iconGenerator";
import { ICONS_PATHS } from "helpers/constants";
import { GET_DIAGNOSTIC_ORDERS_LIST_BY_MOBILE } from "graphql/diagnostics";
import { SignedinState } from "components/enums/SignedinState";
import { useOTP } from "components/OTPProvider";
import { useRouter } from "next/router";
const iconPathsMyhealth = ICONS_PATHS.slice(0, 4);
// Components should always be declared outside the React Functional Component

const DynamicProtectedWithLoginPopup = dynamic(
  () =>
    import("components/ProtectedWithLoginPopup").then(
      (defaultComponent) => defaultComponent.ProtectedWithLoginPopup
    ),
  { ssr: false }
);

interface ProfileProps {
  sectionName?: string;
}

const Profile: React.FC<ProfileProps> = (props) => {
  const [isLoginPopupVisible, setIsLoginPopupVisible] = useState<boolean>(
    false
  );
  const router = useRouter();
  const { sectionName } = props;
  const { currentPatient } = useAuth();
  const { isSignedIn, signOut, isSigningIn } = useAuth();
  const { setVerifyOtpError } = useOTP();
  const MILLISECONDS_IN_A_YEAR = 1000 * 60 * 60 * 24 * 365;
  const [mobileNumber, setMobileNumber] = useState<string>("");
  const patientDetails = getPatientDetails(currentPatient);
  const apolloClient = useApolloClient();
  const getAge = (dob: string) => {
    if (dob?.length) {
      const years_elapsed =
        (new Date().getTime() - new Date(dob).getTime()) /
        MILLISECONDS_IN_A_YEAR;
      return ` | ${Math.ceil(years_elapsed)}`;
    }
    return null;
  };
  const avatarRef = useRef(null);
  const [otp, setOtp] = useState<string>("");

  const handleClickProfileIcon = () => {
    dataLayerTracking({
      event: "icon_click",
      icon_name: "My Profile",
      section_name: sectionName,
    });
  };

  useEffect(() => {
    // fetchUpdatedSubscriptions();
  }, [isSignedIn]);

  const fetchOrderList = () => {
    apolloClient
      .query<
        getDiagnosticOrdersListByMobile,
        getDiagnosticOrdersListByMobileVariables
      >({
        query: GET_DIAGNOSTIC_ORDERS_LIST_BY_MOBILE,
        variables: {
          mobileNumber: currentPatient?.mobileNumber.toString(),
          paginated: true,
          offset: 1,
          limit: 1,
        },
        fetchPolicy: "no-cache",
      })
      .then(({ data }) => {
        if (data?.getDiagnosticOrdersListByMobile?.ordersList?.length > 0) {
          const filteredOrderList = data.getDiagnosticOrdersListByMobile.ordersList.filter(
            (item: OrderListByMobile) => {
              if (item?.diagnosticOrderLineItems?.length > 0) {
                return item;
              }
            }
          );
          const clevertapData = {
            ...getCommonPatientAttributes(currentPatient),
            Source: "My Account",
            "Latest orderid": filteredOrderList[0]?.displayId,
            "Latest order status": getDiagnosticStatus(
              filteredOrderList[0]?.orderStatus
            ),
            City: filteredOrderList[0]?.city || "Not available",
            CityId: filteredOrderList[0]?.cityId || "Not available",
          };
          clevertapTracking("Diagnostic My Orders page viewed", clevertapData);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };
  return (
    <ClickAwayListener
      onClickAway={(e) => {
        setIsLoginPopupVisible(false);
      }}
    >
      <div className={styles.profileContainer} onClick={handleClickProfileIcon}>
        {isSignedIn === SignedinState.SIGNEDIN ? (
          <></>
        ) : (
          <DynamicProtectedWithLoginPopup
            handleClickProfileIcon={handleClickProfileIcon}
          >
            {({ protectWithLoginPopup }) => (
              <>
                <div
                  id="loginPopup"
                  className={`${styles.userAccount} ${styles.userActive}`}
                  onClick={() => protectWithLoginPopup()}
                  ref={avatarRef}
                  title={"Login/SignUp"}
                >
                  {isSigningIn ? (
                    <CircularProgress />
                  ) : (
                    <span className="icon-ic_account" />
                  )}
                </div>
              </>
            )}
          </DynamicProtectedWithLoginPopup>
        )}

        {isSigningIn ? (
          <></>
        ) : (
          <>
            <div
              className={styles.userAccount}
              id="loginPopup"
              onClick={() => setIsLoginPopupVisible(!isLoginPopupVisible)}
              ref={avatarRef}
              title={"Login/SignUp"}
            >
              {isSigningIn ? (
                <CircularProgress />
              ) : (
                <span className="icon-ic_account" />
              )}
            </div>
          </>
        )}
        {isSignedIn !== SignedinState.SIGNEDIN ? (
          <></>
        ) : (
          <div
            className={`${styles.userAccountDetails} ${
              isLoginPopupVisible ? styles.userListActive : ""
            }`}
            onClick={() => {
              setIsLoginPopupVisible(false);
            }}
          >
            {currentPatient && (
              <div className={styles.userDetails}>
                <Typography component="h2">
                  {currentPatient.firstName}
                </Typography>
                <Typography>UHID : {currentPatient.uhid}</Typography>
                <div className={styles.userInfo}>
                  <Typography>
                    {currentPatient.gender}
                    {getAge(currentPatient.dateOfBirth)}
                  </Typography>
                  <Typography>{currentPatient.mobileNumber}</Typography>
                </div>
              </div>
            )}
            <ul className={styles.userAccountList}>
              <li>
                <Link href={clientRoutes.myAccount()} prefetch={false}>
                  <a
                    onClick={() => {
                      /**Gtm code start start */
                      dataLayerTracking({
                        event: "Profile Accessed",
                        Type: "Account",
                      });
                      eventTracking("My Account Family Member Clicked", {
                        ...getPatientAttributes(patientDetails),
                        Nav_src: "Control Profile",
                      });
                      /**Gtm code start end */
                    }}
                  >
                    <span>
                      <img
                        src={`${process.env.NEXT_PUBLIC_247_CDN_URL}/images/ic_manageprofile.svg`}
                        alt="Manage Profiles"
                      />{" "}
                      Manage Family Members
                    </span>
                    <img
                      src={`${process.env.NEXT_PUBLIC_247_CDN_URL}/images/ic_arrow_right.svg`}
                      alt="Right Arrow"
                    />
                  </a>
                </Link>
              </li>

              <li>
                <Link href={clientRoutes.addressBook()} prefetch={false}>
                  <a
                    onClick={() => {
                      /**Gtm code start start */
                      dataLayerTracking({
                        event: "Profile Accessed",
                        Type: "Address Book",
                      });
                      /**Gtm code start end */
                      eventTracking("My Account  Address Book Clicked", {
                        ...getPatientAttributes(patientDetails),
                        Nav_src: "Control Profile",
                      });
                    }}
                  >
                    <span>
                      <span className="icon-ic_location" /> Address Book
                    </span>
                    <img
                      src={`${process.env.NEXT_PUBLIC_247_CDN_URL}/images/ic_arrow_right.svg`}
                      alt="Right Arrow"
                    />
                  </a>
                </Link>
              </li>

              <li>
                <Link href={clientRoutes.myMembership()} prefetch={false}>
                  <a
                    onClick={() => {
                      eventTracking("My Account Membership Clicked", {
                        ...getPatientAttributes(patientDetails),
                        Nav_src: "Control Profile",
                      });
                    }}
                  >
                    <span>
                      <img
                        src={`${process.env.NEXT_PUBLIC_247_CDN_URL}/images/my_membership.svg`}
                        width="24"
                        alt="my membership"
                      />{" "}
                      My Memberships
                    </span>
                    <img
                      src={`${process.env.NEXT_PUBLIC_247_CDN_URL}/images/ic_arrow_right.svg`}
                      alt="next"
                    />
                  </a>
                </Link>
              </li>

              {currentPatient && (
                <li>
                  <Link href={clientRoutes.yourOrders()} prefetch={false}>
                    <a
                      onClick={() => {
                        fetchOrderList();
                        /**Gtm code start start */
                        dataLayerTracking({
                          event: "Profile Accessed",
                          Type: "Orders",
                        });
                        /**Gtm code start end */
                        eventTracking("My Account Orders Clicked", {
                          ...getPatientAttributes(patientDetails),
                          Nav_src: "Control Profile",
                        });
                      }}
                    >
                      <span>
                        <img
                          src={`${process.env.NEXT_PUBLIC_247_CDN_URL}/images/ic_invoice.svg`}
                          alt="My Orders"
                        />{" "}
                        My Orders
                      </span>
                      <img
                        src={`${process.env.NEXT_PUBLIC_247_CDN_URL}/images/ic_arrow_right.svg`}
                        alt="Right Arrow"
                      />
                    </a>
                  </Link>
                </li>
              )}

              <li>
                <Link href={clientRoutes.myPayments()} prefetch={false}>
                  <a
                    onClick={() => {
                      /**Gtm code start start */
                      dataLayerTracking({
                        event: "Profile Accessed",
                        Type: "Payments",
                      });
                      /**Gtm code start end */
                      eventTracking("My Account Payment Clicked", {
                        ...getPatientAttributes(patientDetails),
                        Nav_src: "Control Profile",
                      });
                    }}
                  >
                    <span>
                      <img
                        src={`${process.env.NEXT_PUBLIC_247_CDN_URL}/images/ic_fees.svg`}
                        alt="My Payments"
                      />{" "}
                      Transactions and Payments
                    </span>
                    <img
                      src={`${process.env.NEXT_PUBLIC_247_CDN_URL}/images/ic_arrow_right.svg`}
                      alt="Right Arrow"
                    />
                  </a>
                </Link>
              </li>
              {currentPatient && (
                <li>
                  <Link href={clientRoutes.healthRecords("")} prefetch={false}>
                    <a
                      onClick={() => {
                        /**Gtm code start start */
                        dataLayerTracking({
                          event: "Profile Accessed",
                          Type: "Health Records",
                        });
                        /**Gtm code start end */
                        eventTracking("My Account Health Records Clicked", {
                          ...getPatientAttributes(patientDetails),
                          Nav_src: "Control Profile",
                        });
                      }}
                    >
                      <span>
                        <GenerateIcon
                          pathName={iconPathsMyhealth}
                          iconClass={"icon-ic_myhealth"}
                        />{" "}
                        Health Records
                      </span>
                      <span className="icon-ic_arrow_right" />
                    </a>
                  </Link>
                </li>
              )}
              <li>
                <Link
                  href={clientRoutes.oneApolloMembership()}
                  prefetch={false}
                >
                  <a
                    onClick={() => {
                      eventTracking("My Account One Apollo Membership Cicked", {
                        ...getPatientAttributes(patientDetails),
                        Nav_src: "Control Profile",
                      });
                    }}
                  >
                    <span>
                      <img
                        src={`${process.env.NEXT_PUBLIC_247_CDN_URL}/images/one-apollo.svg`}
                        width="25"
                        alt="One Apollo Membership"
                      />
                      One Apollo Membership
                    </span>
                    <img
                      src={`${process.env.NEXT_PUBLIC_247_CDN_URL}/images/ic_arrow_right.svg`}
                      alt="Right Arrow"
                    />
                  </a>
                </Link>
              </li>
              <li>
                <Link href={clientRoutes.needHelp()} prefetch={false}>
                  <a
                    onClick={() => {
                      /**Gtm code start start */
                      dataLayerTracking({
                        event: "Profile Accessed",
                        Type: "Help",
                      });
                      /**Gtm code start end */
                      eventTracking("My Account Need help Clicked", {
                        ...getPatientAttributes(patientDetails),
                        Nav_src: "Control Profile",
                      });
                    }}
                  >
                    <span>
                      <img
                        src={`${process.env.NEXT_PUBLIC_247_CDN_URL}/images/ic_round_live_help.svg`}
                        alt="Need Help"
                      />{" "}
                      Need Help
                    </span>
                    <img
                      src={`${process.env.NEXT_PUBLIC_247_CDN_URL}/images/ic_arrow_right.svg`}
                      alt="Right Arrow"
                    />
                  </a>
                </Link>
              </li>

              <li>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    eventTracking("User Logout Clicked", {
                      ...getPatientAttributes(patientDetails),
                      Nav_src: "Control Profile",
                    });
                    signOut();
                  }}
                >
                  <span>
                    <img
                      src={`${process.env.NEXT_PUBLIC_247_CDN_URL}/images/ic_logout.svg`}
                      alt="Logout"
                    />{" "}
                    Logout
                  </span>
                </a>
              </li>
            </ul>

            <div className={styles.downloadOptions}>
              <img
                src={`${process.env.NEXT_PUBLIC_247_CDN_URL}/images/apollo247.png`}
              />
              <AphButton
                color="primary"
                onClick={() => {
                  dataLayerTracking({
                    event: "button_click",
                    button_name: "Download App",
                    section_name: "My Profile",
                  });
                  window.open(getAppStoreLink());
                }}
                className={styles.downloadAppBtn}
              >
                Download App
              </AphButton>
            </div>
          </div>
        )}
      </div>
    </ClickAwayListener>
  );
};

export default Profile;
